import {useSelector} from 'react-redux';
import {loginModule} from './LoginDucks';

export default function useUser() {
	return useSelector((state) => state[loginModule].user);
}
